import React from 'react'
import { createRoot } from 'react-dom/client'
import Demo from './components/Demo'
import AnimatedCard from './components/AnimatedCard'
import Landing from './components/Landing'
import Sprites from './components/Sprites'

// Function to mount React components
const mountReactComponent = (Component, elementId) => {
  const element = document.getElementById(elementId)
  if (element) {
    const root = createRoot(element)
    root.render(<Component />)
  }
}

// Register all components here
document.addEventListener('turbo:load', () => {
  mountReactComponent(AnimatedCard, 'react-demo')
  mountReactComponent(Landing, 'react-landing')
  mountReactComponent(Sprites, 'react-sprites')
})

// Export components for potential direct use
export { Demo, AnimatedCard } 
